import { filter, isEmpty, isNil, keys, some } from 'lodash'

import { DISH_FIELDS_CONFIG } from '../constants'

const getAvailableDishTableFields = dishes =>
  filter(keys(DISH_FIELDS_CONFIG), fieldName => {
    const fieldConfig = DISH_FIELDS_CONFIG[fieldName]

    if (!fieldConfig.isTableField) {
      return false
    }

    if (!fieldConfig.isHideable) {
      return true
    }

    if (!isNil(fieldConfig.shouldDisplay)) {
      return some(dishes, dish => fieldConfig.shouldDisplay(dish))
    }

    return some(dishes, dish => !isEmpty(dish[fieldConfig.value]))
  })

export default getAvailableDishTableFields
